export const FileTypes_Excel = `<svg title="FileTypes_Excel" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
<path d="M3 3C3 1.34315 4.34315 0 6 0H15L21 6V21C21 22.6569 19.6569 24 18 24H6C4.34315 24 3 22.6569 3 21V3Z" fill="#D3EBE6"/>
<path d="M7 14H8.5V18H7V14Z" fill="#004D39"/>
<path d="M9.83256 12H11.3326V18H9.83256V12Z" fill="#004D39"/>
<path d="M12.6651 8H14.1651V18H12.6651V8Z" fill="#004D39"/>
<path d="M15.4977 10H16.9977V18H15.4977V10Z" fill="#004D39"/>
<path opacity="0.7" d="M15 0L21 6H17C15.8954 6 15 5.10457 15 4V0Z" fill="#004D39"/>
</svg>`;